export default __webpack_public_path__ + "static/media/quizbizz-signup.214556cc.svg";